import { useState, type FormEvent } from "react";
import { motion } from "framer-motion";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ApiError } from "../api/client";
import { useLogin } from "../hooks/useAuth";
import { fadeUp, tap } from "../motion";

export function LoginPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const returnTo = params.get("returnTo") ?? "/";
  const login = useLogin();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login.mutateAsync({ username, password });
      navigate(returnTo, { replace: true });

    } catch (err) {
      if (err instanceof ApiError && err.status === 429) {
        setError("Too many login attempts — please wait a minute and try again.");
      } else {
        setError("Invalid username or password.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="page-center">
      <motion.form className="login-card" onSubmit={onSubmit} variants={fadeUp} initial="hidden" animate="show">
        <h1 className="brand">OT Desk</h1>
        <label htmlFor="username">Username</label>
        <input
          id="username"
          name="username"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <label htmlFor="password">Password</label>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error" role="alert">{error}</p>}
        <motion.button type="submit" className="btn btn-primary" disabled={submitting} {...tap}>
          {submitting ? "Signing in…" : "Sign in"}
        </motion.button>
      </motion.form>
    </div>
  );
}
